import { render } from "./DeleteManyModal.vue?vue&type=template&id=000150e0&scoped=true"
import script from "./DeleteManyModal.vue?vue&type=script&lang=js"
export * from "./DeleteManyModal.vue?vue&type=script&lang=js"

import "./DeleteManyModal.vue?vue&type=style&index=0&id=000150e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000150e0"]])

export default __exports__